import {
  Compass,
  CursorClick,
  SquaresFour,
  ChartLineUp,
  Trophy,
  Question,
  TextAa,
  ChatCircleDots,
  Spinner,
  ListBullets,
  Lightning,
  UsersThree,
} from "@phosphor-icons/react";

export const LIBRARY_NAV = [
  { id: "navigation", label: "Navigation", icon: Compass },
  { id: "buttons", label: "Buttons", icon: CursorClick },
  { id: "cards", label: "Cards", icon: SquaresFour },
  { id: "progress", label: "Progress", icon: ChartLineUp },
  { id: "rewards", label: "Rewards", icon: Trophy },
  { id: "questions", label: "Questions", icon: Question },
  { id: "inputs", label: "Inputs", icon: TextAa },
  { id: "feedback", label: "Feedback", icon: ChatCircleDots },
  { id: "loading", label: "Loading", icon: Spinner },
  { id: "lists", label: "Lists", icon: ListBullets },
  { id: "motion", label: "Motion", icon: Lightning },
  { id: "age", label: "Age Adaptation", icon: UsersThree },
];
